import React from 'react';
import './Footer.css'
import { Link } from 'react-router-dom';

function Footer() {

  const handleEmailButtonClick = () => {
    window.location.href = 'mailto:dxt.applications@email.com?subject=New%20Client%20Request';
  };

  const handleInvestorEmail = () => {
    window.location.href = 'mailto:dxt.applications@email.com?subject=Investment';
  };

  const handleCareerEmail = () => {
    window.location.href = 'mailto:dxt.applications@email.com?subject=Career%20Inquiry';
  };


  
  return (
    <div className='footer-container'>
      {/* //* Newsletter section - might add back at a later date */}
      {/* <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Join the Adventure newsletter to receive our best vacation deals
        </p>
        <p className='footer-subscription-text'>
          You can unsubscribe at any time.
        </p>
        <div className='input-areas'>
          <form>
            <input
              className='footer-input'
              name='email'
              type='email'
              placeholder='Your Email'
            />
            <Button buttonStyle='btn--outline'>Subscribe</Button>
          </form>
        </div>
      </section> */}
      <div class='footer-links'>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>DxT LLC</h2>
            <button className='footer-button investor-button' onClick={handleInvestorEmail}>Investors</button>
            <button className='footer-button careers-button' onClick={handleCareerEmail}>Careers</button>
            {/* <button className='footer-button careers-button' >Terms Of Service</button> */}
          </div>
          <div class='footer-link-items'>
            <h2>Client Contact</h2>
            <button className='footer-button careers-button' onClick={handleEmailButtonClick}>Email DxT</button>
          </div>
        </div>
        <div className='footer-link-wrapper'>
          {/* <div class='footer-link-items'>
            <h2>Videos</h2>
            <Link to='/'>Submit Video</Link>
            <Link to='/'>Ambassadors</Link>
            <Link to='/'>Agency</Link>
            <Link to='/'>Influencer</Link>
          </div> */}
          {/* <div class='footer-link-items'>
            <h2>Social Media</h2>
            <Link to='https://www.instagram.com/dxt_llc/'>Instagram</Link>
            <Link to='/'>Facebook</Link>
            <Link to='/'>Youtube</Link>
            <Link to='https://twitter.com/dxt_llc'>Twitter</Link>
          </div> */}
          <div class='footer-link-items'>
            <h2>Solutions & Services</h2>
            <Link to='https://dxtapps.com/entrata/'>Entrata Dashboard</Link>
            <Link to='https://dxtapps.com/expensetracker.html'>Expense Tracker</Link>
            <button className='footer-button careers-button' onClick={handleEmailButtonClick}>Request Software</button>
            {/* <Link to=''>Tasker</Link> */}
          </div>
          <div class='footer-link-items'>
            <h2>For Fun</h2>
            <Link to='/'>Chess with Friends</Link>
          </div>
        </div>
      </div>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              DxT LLC
              <i class='fab fa-typo3' />
            </Link>
          </div>
          <small class='website-rights'>DxT LLC © 2024</small>
          {/* <div class='social-icons'>
            <Link
              class='social-icon-link instagram'
              to='https://www.instagram.com/dxt_llc/'
              target='_blank'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='https://twitter.com/dxt_llc'
              target='_blank'
              aria-label='Twitter'
            >
              <i class='fab fa-twitter' />
            </Link>
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default Footer;


{/* <Link
    class='social-icon-link youtube'
    to='/'
    target='_blank'
    aria-label='Youtube'
>
    <i class='fab fa-youtube' />
</Link> */}

{/* <Link
    class='social-icon-link twitter'
    to='/'
    target='_blank'
    aria-label='LinkedIn'
>
    <i class='fab fa-linkedin' />
</Link> */}

{/* <Link
    class='social-icon-link facebook'
    to='/'
    target='_blank'
    aria-label='Facebook'
>
    <i class='fab fa-facebook-f' />
</Link> */}